// setTimeout(() => {
    
//     $ = jQuery;
    
//     $(document).ready( () => {
//         console.log('running...')
//         $('.ibtesting').each( (element) => {
//             let parent = element.parent();
    
//             $(element).css({
//                 top: parent.height()/2 - child.height()/2,
//                 left: parent.width()/2 - child.width()/2
//             })
//         } )
//     } );
// }, 1000);

// window.onload = function() {

//     let tick = setInterval(() => {
//         if (window.jQuery) {  
//         // jQuery is loaded  
//         console.log('loaded..')
//         clearInterval(tick);

        
//         }
//     }, 25);    
// }

function centerPlayButtons() {
  // Page has loaded and theme assets are ready

  let targets = document.getElementsByClassName("play-button");

  Array.from(targets).forEach( (element, index) => {
      let parent = element.parentElement;

      Object.assign(element.style, {
        top: '-' + (parent.clientHeight * .5) +'px',
        left: (parent.clientWidth * .5) +'px'
      });

  } );
}

// recenter on resize
window.addEventListener('resize', centerPlayButtons);

// initial center
document.addEventListener('page:loaded', centerPlayButtons);